import { Component, Renderer2 } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { SidebarService } from 'src/app/components/app-sidebar-minimizer/sidebar.service';

function isOverflown(element: HTMLElement) {
	return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

@Component({
  standalone: false,
	selector: 'app-layout',
	template: `
		<app-header></app-header>
		<app-sidebar></app-sidebar>
		<div class="sidebar-mobile-backdrop" (click)="closeMobileSidebar()"></div>
		<div class="app-body">
			<ngx-spinner [zIndex]="4999" size="medium" color="var(--kcs-primary)" bdColor="#00000017" name="body" type="ball-clip-rotate"></ngx-spinner>
			<div class="body">
				<div class="body-container">
					<app-breadcrumbs></app-breadcrumbs>
					<router-outlet></router-outlet>
					<app-footer class="footer"></app-footer>
				</div>
			</div>
		</div>
	`,
})
export class FullLayoutComponent {
	constructor(private sidebarService: SidebarService, private renderer: Renderer2) {
		this.sidebarService.minimized$.subscribe((min) => {
			if (min) {
				this.renderer.addClass(document.body, 'sidebar-minimized');
			} else {
				this.renderer.removeClass(document.body, 'sidebar-minimized');
			}
		});
	}

	closeMobileSidebar() {
		document.body.classList.remove('sidebar-mobile-show');
	}
}
